'use client';

import * as PopoverPrimitive from '@radix-ui/react-popover';
import * as React from 'react';
import { cn } from 'v5/platform/dom/cn';

const Popover = PopoverPrimitive.Root;

const PopoverTrigger = PopoverPrimitive.Trigger;

const PopoverContent = React.forwardRef<
  React.ElementRef<typeof PopoverPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof PopoverPrimitive.Content>
>(({ className, align = 'center', sideOffset = 4, ...props }, ref) => (
  <PopoverPrimitive.Portal
    container={document.getElementById('tailwind-portals')}
  >
    <PopoverPrimitive.Content
      ref={ref}
      align={align}
      sideOffset={sideOffset}
      className={cn(
        'z-50 rounded-md border border-border-default bg-bg-default p-4 text-fg-default shadow-md outline-none data-[state=open]:animate-zoomin data-[state=closed]:animate-zoomoutup',
        'max-h-[calc(var(--radix-popover-content-available-height)_-_var(--spacing))] overflow-y-auto',
        [
          'w-auto',
          'min-w-[max(var(--radix-popover-trigger-width),120px)]',
          'max-w-[max(var(--radix-popover-trigger-width),min(500px,var(--radix-popover-content-available-width)))]'
        ],
        className
      )}
      {...props}
    />
  </PopoverPrimitive.Portal>
));
PopoverContent.displayName = PopoverPrimitive.Content.displayName;

export { Popover, PopoverTrigger, PopoverContent };
